import Application from "../../Application";
import ChangePasswordPresenter, {
  IChangePasswordPresenter
} from "../presenter/ChangePasswordPresenter";
import { TPasswordChangePresentationModel } from "../presenter/model/PasswordChangePresentationModel";

export default class ShowChangePasswordInteractor {
  private application: Application;
  private output?: IChangePasswordPresenter;

  constructor({ application }) {
    this.application = application;
  }

  execute(username: string, oldPassword?: string, setPassword?: boolean) {
    this.output = ChangePasswordPresenter({
      application: this.application,
      initialState: {
        password: {
          oldPassword: oldPassword || ""
        } as TPasswordChangePresentationModel,
        submitButtonDisabled: true,
        username: username || "",
        validationPasswordErrors: {} as any,
        setPassword: setPassword !== undefined ? setPassword : false
      }
    });

    return this.output;
  }
}
